export const formatUrlTrailing = (url: string): string =>
	url.match(/\/$/) ? url : url + '/';
